import { failureType, requestType, successType } from 'src/services/api-handlers/api-resolver';
import { Paginated } from '../../services/api-handlers/pagination';

import { Actions } from '../actions/provider-actions';
import { ServiceTypeActions } from '../constants';
import { IServiceType } from 'src/types/service-types';
import { IServiceTypeProvider } from '../../types/service-types-providers';

export interface ServiceTypeState {
    inProgress: boolean;
    authCode: string;
    error: string;
    data: Paginated<IServiceType>;
    dataOrder: Paginated<IServiceType>;
    current: IServiceType | null;
}

export interface ServiceTypeProviderState {
    inProgress: boolean;
    authCode: string;
    error: string;
    data: Paginated<IServiceTypeProvider>;
    dataOrder: Paginated<IServiceTypeProvider>;
    current: IServiceTypeProvider | null;
}

const initialState = {
    inProgress: false,
    authCode: '',
    error: '',
    data: {
        list: [],
        page: 1,
        meta: {
            updatedAt: null,
        },
    },
    dataOrder: {
        list: [],
        page: 1,
        meta: {
            updatedAt: null,
        },
    },
    current: null,
};

export function serviceTypes(state: ServiceTypeState = initialState, action: Actions | any): ServiceTypeState {
    switch (action.type) {
        case requestType(ServiceTypeActions.STAFF_PERSIST_SERVICE_TYPE):
            return { ...state, error: '', inProgress: true };
        case successType(ServiceTypeActions.STAFF_PERSIST_SERVICE_TYPE):
            return { ...state, inProgress: false };
        case failureType(ServiceTypeActions.STAFF_PERSIST_SERVICE_TYPE):
            return { ...state, error: action.error, inProgress: false };
        case requestType(ServiceTypeActions.STAFF_FETCH_SERVICE_TYPES):
            return {
                ...state,
                data: {
                    ...state.data,
                    list: [],
                    page: 1,
                    meta: state.data?.meta?.updatedAt
                        ? state.data?.meta
                        : {
                              updatedAt: null,
                          },
                    inProgress: true,
                },
                error: '',
                inProgress: true,
            };
        case successType(ServiceTypeActions.STAFF_FETCH_SERVICE_TYPES):
            return { ...state, data: action.payload, inProgress: false };
        case failureType(ServiceTypeActions.STAFF_FETCH_SERVICE_TYPES):
            return { ...state, error: action.error, inProgress: false };

        case requestType(ServiceTypeActions.STAFF_FETCH_ORDER_SERVICE_TYPES):
            return {
                ...state,
                data: {
                    ...state.data,
                    list: [],
                    page: 1,
                    meta: state.data?.meta,
                },
                error: '',
                inProgress: true,
            };
        case successType(ServiceTypeActions.STAFF_FETCH_ORDER_SERVICE_TYPES):
            return { ...state, dataOrder: { ...state.dataOrder, list: action.payload }, inProgress: false };
        case failureType(ServiceTypeActions.STAFF_FETCH_ORDER_SERVICE_TYPES):
            return { ...state, error: action.error, inProgress: false };

        case requestType(ServiceTypeActions.STAFF_FETCH_SERVICE_TYPE):
            return { ...state, inProgress: true, current: null, error: '' };
        case successType(ServiceTypeActions.STAFF_FETCH_SERVICE_TYPE):
            return { ...state, inProgress: false, current: action.payload };
        case failureType(ServiceTypeActions.STAFF_FETCH_SERVICE_TYPE):
            return { ...state, inProgress: false, error: action.error };
        case requestType(ServiceTypeActions.STAFF_DELETE_SERVICE_TYPE):
            return { ...state, error: '', inProgress: true };
        case successType(ServiceTypeActions.STAFF_DELETE_SERVICE_TYPE):
            return {
                ...state,
                inProgress: false,
                data: {
                    ...state.data,
                    list: state.data.list.filter((item: IServiceType) => {
                        return item.id !== action.payload.id;
                    }),
                    meta: {
                        updatedAt: 0,
                    },
                },
            };
        case failureType(ServiceTypeActions.STAFF_DELETE_SERVICE_TYPE):
            return { ...state, inProgress: false, error: `Service type has deep relations` ?? 'Unknown error' };
        default:
            return state;
    }
}
